export class UiDeadlineError extends Error {
  constructor(phase, timeoutMs) {
    super(`${phase} did not finish within ${timeoutMs}ms`);
    this.name = "UiDeadlineError";
    this.code = "ui-deadline";
    this.phase = phase;
  }
}

export function withUiDeadline(promise, { phase, timeoutMs = 15000 } = {}) {
  let timeoutId;
  const deadline = new Promise((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new UiDeadlineError(phase || "operation", timeoutMs)),
      timeoutMs,
    );
  });
  return Promise.race([Promise.resolve(promise), deadline]).finally(() => {
    clearTimeout(timeoutId);
  });
}

